<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-30 
-->
<template>
  <div class="main-container">
    <page-header>{{'我的门票' | dealLanguage('My Tickets')}}</page-header>
    <div class="warp">
      <div class="view-title">
        <div class="title">{{'本人的门票' | dealLanguage('My Tickets')}}</div>
        <div class="line"></div>
      </div>
      <div class="ticket-list">
        <div class="ticket-item ticket-container" v-for="item,index in myticket" :key="index">
          <div class="ticket-item-top">
            <div class="ticket-item-top-left">
              <img :src="item.activityShareImagePath | logo_show" />
              <!-- <img :src="item.activityLogoPath | logo_show" /> -->
            </div>
            <div class="ticket-item-top-right">
              <div>
                <div class="title">{{item.activityTicketName | dealLanguage(item.activityEnTicketName)}}</div>
                <div class="desc" v-html="item.remark" v-if="item.remark && language == 'zh'"></div>
                <div class="desc" v-html="item.enRemark" v-if="item.enRemark && language == 'en'"></div>
              </div>
              <div class="source" v-if="item.giveXuserid">{{`受赠于`|dealLanguage(`From`)}} {{item.giveXuserName}} {{item.giveXuserMobile}}</div>
            </div>
          </div>
          <!-- 参会人信息 -->
          <div class="participant">{{'参会人信息：' | dealLanguage('Participant information:')}}{{user.name}} +{{user.mobileAreaCode}} {{user.mobile}}</div>
          <div class="bottom-btn-wrapper">
            <Button @click="handleLook(item.ticketUserRelationId)">{{'查看详情' | dealLanguage('Details')}}</Button>
            <!-- <Button>发送短信通知</Button> -->
            <Button type="primary" @click="handleChangeRouter('signUp')">{{'升级门票' | dealLanguage('Upgrade')}}</Button>
          </div>
        </div>
      </div>
      <div class="more-btn" v-if="!loading && isMore">
        <Button @click="getMore">{{'加载更多' | dealLanguage('More')}}</Button>
      </div>
      <div class="loading-warpper" v-if="loading">
        <van-loading size="20px">{{'加载中' | dealLanguage('Loading')}}...</van-loading>
      </div>
      <nothing v-if="!isMore && !loading && myticket.length == 0">
        <router-link :to="{name: 'signUp'}" class="btn">{{'前往购票' | dealLanguage('Get tickets')}}</router-link>
      </nothing>

      <div class="list">
        <div class="list-item" v-for="(pitem, pindex) in partnerTicket" :key="pindex">
          <div class="view-title">
            <div class="title">{{pitem.partnerName}}{{'的门票' | dealLanguage("'s Tickets")}}</div>
            <div class="line"></div>
          </div>
          <div class="ticket-list">
            <div class="ticket-item ticket-container" v-for="item,index in pitem.ticketList" :key="index">
              <div class="ticket-item-top">
                <div class="ticket-item-top-left">
                  <img :src="item.activityShareImagePath | logo_show" />
                  <!-- <img :src="item.activityLogoPath | logo_show" /> -->
                </div>
                <div class="ticket-item-top-right">
                  <div>
                    <div class="title">{{item.activityTicketName | dealLanguage(item.activityEnTicketName)}}</div>
                    <div class="desc" v-html="item.remark" v-if="item.remark && language == 'zh'"></div>
                    <div class="desc" v-html="item.enRemark" v-if="item.enRemark && language == 'en'"></div>
                  </div>
                  <!-- <div class="source">受赠人</div> -->
                </div>
              </div>
              <!-- 参会人信息 -->
              <div class="participant">{{'参会人信息：' | dealLanguage('Participant information:')}}{{pitem.partnerName}} +{{pitem.partnerMobileAreaCode}} {{pitem.partnerMobile}}</div>
              <div class="bottom-btn-wrapper">
                <Button @click="handleLook(item.ticketUserRelationId)">{{'查看详情' | dealLanguage('Details')}}</Button>
                <Button @click="sendTicketMsg(item.ticketUserRelationId)">{{'发送短信通知' | dealLanguage('SMS Notify')}}</Button>
                <Button type="primary" @click="handleChangeRouter('signUp')">{{'升级门票' | dealLanguage('Upgrade')}}</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Nothing from '@/components/common/nothing.vue'
import PageHeader from '@/components/mobile/pageHeader.vue'
import { myticket, partnerTicket, sendTicketMsg } from '@/service/vbef'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('我的门票', 'My Tickets'),
    }
  },
  inject: ['wxShare'],
  components: {
    Nothing,
    PageHeader,
  },
  created() {
    this.getTicket()
    this.getPartnerTicket()
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('我的门票-2025VBEF大会', 'My Tickets-2025VBEF Conference'),
      linkurl: this.vbef_path + '/myTickets',
      
    })
    if (!this.user_key) {
      this.$router.push('/')
      this.$notify(filter.dealLanguage('请先登录', 'Please log in first'))
    }

    // window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    // window.removeEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      page: 1,
      myticket: [],
      loading: false,
      isMore: false,
      partnerTicket: [],
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      language: (state) => state.language,
    }),
  },
  methods: {
    // handleScroll() {
    //   let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    //   let windowHeight = document.documentElement.clientHeight || document.body.clientHeight

    //   const listbox = this.$refs['indexlist-bottom']
    //   const listrect = listbox.getBoundingClientRect()
    //   const listabsoluteTop = listrect.top + scrollTop
    //   if (
    //     scrollTop + windowHeight >= listabsoluteTop &&
    //     scrollTop > 0 &&
    //     !this.loading &&
    //     this.isMore
    //   ) {
    //     this.getMore()
    //   }
    // },
    async getTicket() {
      this.loading = true
      let res = await myticket({
        dataType: 2,
        page: this.page,
        size: 10,
        ticketStatus: 0,
      })
      this.loading = false
      if (res.code == 0) {
        this.myticket = [...this.myticket, ...res.data]
        this.isMore = res.data.length == 10
      }
    },
    async getPartnerTicket() {
      let res = await partnerTicket({
        activityId: this.activityId,
        dataType: 2,
        ticketStatus: 0,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'partnerTicket', res.data.partnerTicketInfos)
      }
    },
    async sendTicketMsg(rowId) {
      let res = await sendTicketMsg({
        ticketUserRelationId: rowId
      })
      if (res.code == 0) {
        this.$notify({ type: 'success', message: filter.dealLanguage('发送成功！', 'Send successfully') })
      } else {
        this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    getMore() {
      this.page++
      this.getTicket()
    },
    handleLook(rowId) {
      this.$router.push({ name: 'ticketDetail', params: { id: rowId } })
    },
    handleChangeRouter(name) {
      this.$router.push({ name })
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
@import '~styles/form-view-m.styl'
@import '~styles/ticket-item-m.styl'
.list
  margin-top .4rem
  > .list-item + .list-item
    margin-top .4rem
.warp
  padding 0.4rem
  .ticket-list
    .ticket-item
      &+.ticket-item
        margin-top 0.2rem
.more-btn
  margin-top 0.2rem
  font-size 0
  text-align center
  .ivu-btn
    color #FA5A00
    box-shadow none
    transition all 0.3s
    font-size 14px
    padding 0
    height auto
    border 0
    &:hover
      color #FF4800
</style>